/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePopiaStatusModel
 */
export interface UpdatePopiaStatusModel {
    /**
     * 
     * @type {string}
     * @memberof UpdatePopiaStatusModel
     */
    popiaStatus: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdatePopiaStatusModel
     */
    detailsLastUpdated?: Date;
}

/**
 * Check if a given object implements the UpdatePopiaStatusModel interface.
 */
export function instanceOfUpdatePopiaStatusModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "popiaStatus" in value;

    return isInstance;
}

export function UpdatePopiaStatusModelFromJSON(json: any): UpdatePopiaStatusModel {
    return UpdatePopiaStatusModelFromJSONTyped(json, false);
}

export function UpdatePopiaStatusModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePopiaStatusModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'popiaStatus': json['PopiaStatus'],
        'detailsLastUpdated': !exists(json, 'DetailsLastUpdated') ? undefined : (new Date(json['DetailsLastUpdated'])),
    };
}

export function UpdatePopiaStatusModelToJSON(value?: UpdatePopiaStatusModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PopiaStatus': value.popiaStatus,
        'DetailsLastUpdated': value.detailsLastUpdated === undefined ? undefined : (value.detailsLastUpdated.toISOString()),
    };
}

